<template>
  <button
    :id="this.buttonId"
    @click.stop="buttonClick()"
    :class="['btn', isOneOfExpectedAspectType ? `btn_${this.aspectType}` : `btn_${defaultAspect}`]"
    :style="cssProps"
    data-testid="sbx-pcc_button"
  >
    <span>
      {{ this.buttonTitle }}
    </span>
  </button>
</template>

<script>
import { sbxButton } from './index.js';
import { brandPrimaryColor1, brandHighlightCardBg } from '@/SharedFe/scss/brand.module.scss';

export default {
  name: 'sbxButton',
  props: {
    ...sbxButton.propTypes,
  },
  computed: {
    cssProps() {
      return {
        '--priButtonColor': this.primaryColor ? this.primaryColor : brandPrimaryColor1,
        '--secButtonColor': this.secondaryColor ? this.secondaryColor : brandHighlightCardBg,
      };
    },
    defaultAspect() {
      return sbxButton.propTypes.aspectType.default;
    },
    isOneOfExpectedAspectType() {
      return ['pill', 'button'].includes(this.aspectType);
    },
  },
};
</script>
<style lang="scss" scoped>
@import '@/SharedFe/scss/variables.scss';

$priButtonColor: var(--priButtonColor);
$secButtonColor: var(--secButtonColor);

.btn {
  width: 100%;
  height: 50px;
  max-width: 230px;
  box-sizing: border-box;
  font-size: rem-calc(18);
  line-height: rem-calc(22);
  padding: rem-calc(14);
  margin: auto 0;
  background-color: $secButtonColor;
  color: $priButtonColor;
  text-align: center;
  border: none;
  font-family: $brand-font-regular;

  &_pill {
    border-radius: rem-calc(25);
  }

  &_button {
    border-radius: rem-calc(4);
  }

  &:hover {
    background-color: $priButtonColor;
    color: $secButtonColor;
    cursor: pointer;
  }
}
</style>
